import { setLocale as setVeevalidateLocale } from '@vee-validate/i18n'
import dayjs from 'dayjs'
import { Quasar } from 'quasar'
import quasarLangEn from 'quasar/lang/en-US'
import quasarLangRu from 'quasar/lang/ru'

import { useCookie } from '@/shared/lib/composables/useCookie'

export const UPLATFORM_LOCALE_KEY = 'uplatform_corp_portal_lang'

export type AvailableLocale = 'ru' | 'en'

const applyQuasarLangPack = (code: string) => {
  Quasar.lang.set(code === 'ru' ? quasarLangRu : quasarLangEn)
}

export const useUplatformLocale = () => {
  const savedLocale = useCookie(UPLATFORM_LOCALE_KEY)
  const { locale } = useI18n()
  const currentLocale = computed<AvailableLocale>(() => locale.value as AvailableLocale)

  const updateLocale = () => {
    if (savedLocale.value) {
      locale.value = savedLocale.value
    } else {
      locale.value = window?.navigator.language.slice(0, 2)
      savedLocale.value = locale.value
    }
    dayjs.locale(locale.value)
    setVeevalidateLocale(locale.value)
    applyQuasarLangPack(String(locale.value))
  }

  const setLocale = (val: AvailableLocale) => {
    savedLocale.value = val
    locale.value = val
    dayjs.locale(locale.value)
    setVeevalidateLocale(locale.value)
    applyQuasarLangPack(val)
  }

  return {
    updateLocale,
    setLocale,
    currentLocale,
  }
}
